module.exports = "https://cdn.realtymogul.com/static/media/icon_core.087af45c.svg";